import { ApiService as api } from '@/services/axiosHelper';
import { SET_CUSTOMER, TOAST_MESSAGES_PUSH } from './mutation-types';

export default {
	strict: process.env.NODE_ENV !== 'production',
	name: 'customer',
	namespaced: true,
	state: {
		customer: {}
	},
	mutations: {
		[SET_CUSTOMER](state, customer) {
			state.customer = customer;
		}
	},
	actions: {
		async loadCustomerById({ commit, dispatch }, id) {
			await api
				.get(`/customer/${id}`)
				.then(res => {
					commit(SET_CUSTOMER, res);
					return res;
				})
				.catch(error => {
					dispatch(
						TOAST_MESSAGES_PUSH,
						{
							statusCode: 400,
							message: error
						},
						{
							root: true
						}
					);
				});
		}
	},
	getters: {
		customer: state => state.customer
	}
};
